<div
  class='container-col-flex-max ltr'
  [ngClass]='cService.currentTheme'
  [class.dark]='cService.isDarkTheme'
  [dir]="cService.selectedLanguage?.isRtl ? 'rtl' : 'ltr'"
  (window:resize)='cService.applyBreakpoint()'
  [matTooltip]="cService.prodDataInUseInDev ? 'You are using PRODUCTION API in DEVELOPMENT' : ''"
  [class.production-data-in-use-in-dev]='cService.prodDataInUseInDev'
>
  <mat-progress-bar
    style='position: absolute; top: 0'
    [class.hidden]='cService.hideIndeterminateProgress'
    color='primary'
    mode='indeterminate'
  ></mat-progress-bar>

  <!--  App header -->
  <mat-toolbar
    class='main-headers app-toolbar'
    [style.padding-left]="cService.selectedLanguage?.isRtl ? '0' : ''"
    [style.border-color]="'#' + cService.userProfile?.HqColour"
    [class.hidden]='cService.userProfile?.embedded && !cService.isPcViewport'
  >
    <div class='margin-t-10'>
      <img
        [src]="cService.imageRoot + 'virtualRiskManager.png'"
        *ngIf='!cService.isMobileViewport'
        alt='VRM Mentor Logo'
        style='width: 300px'
      />
    </div>

    <!-- Client's Company Logo " -->
    <div *ngIf='!cService.reloadingLanguage' fxLayout='row' fxLayoutAlign='center' fxFlex>
      <img
        *ngIf='cService.userProfile && cService.userProfile.companyLogo'
        [src]='cService.userProfile.logo'
        [src-fallback]="cService.companiesLogoRoot + 'logo-blank.jpg'"
        [style.width]="
					bespokeLogoSize[cService.userProfile.companyLogo]
						? bespokeLogoSize[cService.userProfile.companyLogo]
						: '300px'
				"
        [style.margin-left]="
					cService.userProfile.company?.toLowerCase() === 'bayer' && cService.isPcViewport ? '5vw' : ''
				"
        [style.margin-right]="
					cService.userProfile.company?.toLowerCase() === 'bayer' &&
					!cService.isPcViewport &&
					!cService.isMobileViewport
						? '5vh'
						: ''
				"
      />
    </div>

    <div fxLayout='row' *ngIf='cService.isPcViewport; else combinedMenuOptions'>
      <div fxLayout='row' class='flex-max' fxLayoutAlign='end' *ngIf='!cService.reloadingLanguage'>
        <!-- Language menu -->
        <div
          class='margin-r-10'
          *ngIf='!authService.isAuthenticated() || cService.pageHeader.pageUiSettings?.hasTranslationSwitch'
        >
          <button
            data-cy='language-menu'
            type='button'
            mat-button
            [matMenuTriggerFor]='languageMenu'
            [matTooltip]="'Language: ' + cService.selectedLanguage?.country"
          >
            <span class='bold'>{{ cService.selectedLanguage?.translatedLabel }}</span>
            <mat-icon style='line-height: 22px'>arrow_drop_down</mat-icon>
          </button>
          <mat-menu #languageMenu='matMenu' [overlapTrigger]='false'>
            <button
              type='button'
              mat-menu-item
              *ngFor='let lang of cService.vrmLanguages'
              (click)='cService.setAndCacheLanguageCode(lang.code, true)'
              class='language-menu-button'
              [disabled]='lang.code === cService.selectedLanguage?.code'
            >
              <span>{{ lang.translatedLabel }}</span>
              <small style='width: 86%'>{{ lang.country }}</small>
            </button>
          </mat-menu>
        </div>

        <!-- Options -->
        <div
          class='padding-r-10'
          data-cy='more-options-menu'
          *ngIf='!authService.isAuthenticated() || cService.pageHeader.pageUiSettings?.hasMoreOptions'
        >
          <button type='button' mat-icon-button [matMenuTriggerFor]='moreMenu'>
            <mat-icon aria-label='more'>more_vert</mat-icon>
          </button>
          <mat-menu #moreMenu='matMenu' [overlapTrigger]='false'>
            <check-updates-button
              (onCheckUpdates)='manuallyCheckUpdates()'
              [appVersion]='cService.appVersion'
            ></check-updates-button>

            <button
              type='button'
              mat-menu-item
              (click)='toggleFullScreen()'
              *ngIf='cService.userProfile && !cService.userProfile?.embedded'
            >
              <mat-icon>fullscreen</mat-icon>
              <span>{{ 'OPTIONS.fullscreen' | translate }}</span>
            </button>

            <div *ngIf='authService.isAuthenticated()'>
              <settings-button
                (triggerSidenav)='toggleSettingsSidenav(authService.accountAndSecTabs.account)'
              ></settings-button>
              <logout-button
                (onLogout)='logout()'
                *ngIf='cService.userProfile && !cService.userProfile?.embedded'
              ></logout-button>
            </div>
          </mat-menu>
        </div>
      </div>
    </div>

    <!-- Mobile - Combined options -->
    <ng-template #combinedMenuOptions>
      <div
        class='padding-t-10; padding-r-10'
        *ngIf='!authService.isAuthenticated() || cService.pageHeader.pageUiSettings?.hasMoreOptions'
      >
        <button type='button' mat-icon-button [matMenuTriggerFor]='moreMenu' data-cy='mobile-options-menu'>
          <mat-icon aria-label='more'>more_vert</mat-icon>
        </button>
        <mat-menu #moreMenu='matMenu' [overlapTrigger]='false'>
          <button
            *ngIf='
							!authService.isAuthenticated() || cService.pageHeader.pageUiSettings?.hasTranslationSwitch
						'
            mat-menu-item
            [matMenuTriggerFor]='languageMenu'
            [matTooltip]="'GENERIC.language' | translate"
            data-cy='mobile-language-options-button'
          >
            <mat-icon style='position: relative; top: 12px'>language</mat-icon>
            <span fxFlex></span>
            <strong>{{ cService.selectedLanguage?.translatedLabel | uppercase }}</strong>
          </button>
          <mat-menu #languageMenu='matMenu' [overlapTrigger]='false'>
            <button
              type='button'
              mat-menu-item
              *ngFor='let lang of cService.vrmLanguages'
              (click)='cService.setAndCacheLanguageCode(lang.code, true)'
              class='language-menu-button'
              [disabled]='lang.code === cService.selectedLanguage?.code'
            >
              <span>{{ lang.translatedLabel }}</span>
              <small style='width: 86%'>{{ lang.country }}</small>
            </button>
          </mat-menu>

          <check-updates-button
            (onCheckUpdates)='manuallyCheckUpdates()'
            [appVersion]='cService.appVersion'
          ></check-updates-button>

          <div *ngIf='authService.isAuthenticated()'>
            <settings-button
              (triggerSidenav)='toggleSettingsSidenav(authService.accountAndSecTabs.security)'
            ></settings-button>
            <logout-button (onLogout)='logout()'></logout-button>
          </div>
        </mat-menu>
      </div>
    </ng-template>
  </mat-toolbar>

  <!-- Local page header - applied globally due to new design -->
  <vrm-page-header *ngIf='authService.isAuthenticated() && cService.pageHeader.pageUiSettings?.hasMainHeader'>
		<span
      style='position: relative'
      [style.top]="
				cService.pageHeader.pageTitle && cService.pageHeader.pageTitle.startsWith('::') ? '1px' : '11px'
			"
      [class.light-red-text]="cService.pageHeader.pageTitle && cService.pageHeader.pageTitle.startsWith('::')"
    >
			<span *ngIf='cService.appReady'>{{ cService.pageHeader.pageTitle }}</span>
		</span>
    <button
      mat-icon-button
      [matTooltip]="'GENERIC.refresh' | translate"
      (click)='reloadApp()'
      *ngIf="cService.pageHeader.pageTitle && cService.pageHeader.pageTitle.startsWith('::')"
    >
      <mat-icon>refresh</mat-icon>
    </button>
  </vrm-page-header>

  <!-- Navigation sidenav -->
  <mat-sidenav-container class='main-sidenav-container'>
    <mat-sidenav
      #mainSidenav
      *ngIf='authService.isAuthenticated() && cService.pageHeader.pageUiSettings?.hasMainNav'
      [mode]="cService.isPcViewport ? 'side' : 'over'"
      [(opened)]='cService.mainSidenavOpened'
    >
      <div class='container-col-flex-max'>
        <!-- Distributor switch and company label -->
        <distributor-autocomplete-switch class='no-elevation-but-underline'></distributor-autocomplete-switch>

        <!-- Nav body -->
        <div class='flex-max' style='overflow: auto' *ngIf='cService.navigation.length > 0'>
          <mat-accordion displayMode='flat'>
            <ng-container *ngFor='let nav of cService.navigation'>
              <mat-expansion-panel
                [id]='nav.id'
                class='nav-expansion no-elevation-but-underline sharp-corners'
                *ngIf='!nav.hidden'
                [disabled]='nav.disabled'
                [expanded]='nav.expanded'
                [class.selected-nav]='nav.selected'
              >
                <mat-expansion-panel-header
                  collapsedHeight='48px'
                  expandedHeight='48px'
                  *ngIf='!nav.url; else renderAsDirectLink'
                >
                  <mat-panel-title>
                    <span *ngIf='!nav.trademark'>{{ nav | getNavTitle }}</span>
                    <span *ngIf='nav.trademark'>{{ nav.fallbackName }}</span>
                    <render-trademarks [trademark]='nav.trademark'></render-trademarks>
                    <span *ngIf='nav.fallbackTextAfterTrademark'
                    >&nbsp;{{
                      nav.translatedTextAfterTrademark
                        ? nav.translatedTextAfterTrademark
                        : nav.fallbackTextAfterTrademark
                      }}</span
                    >
                  </mat-panel-title>
                </mat-expansion-panel-header>

                <ng-template #renderAsDirectLink>
                  <mat-nav-list (click)='identifySelectedNav(nav)' style='padding-top: 0'>
                    <a
                      mat-list-item
                      [href]='nav.url'
                      [target]="nav.openInNewTab ? '_blank' : ''"
                      [class.selected-child-nav]='nav.selected'
                      *ngIf='!nav.disabled'
                    >
                      <h3 class='menu-title' matLine style='margin-left: 8px'>
												<span
                          fxFlex
                          [class.align-text-with-icon-0]="
														nav.isExternalUrl || nav.name === 'DVCR'
													"
                        >
													<span *ngIf='!nav.trademark'>{{ nav | getNavTitle }}</span>
													<span *ngIf='nav.trademark'>{{ nav.fallbackName }}</span>
													<render-trademarks [trademark]='nav.trademark'></render-trademarks>
													<span *ngIf='nav.fallbackTextAfterTrademark'
                          >&nbsp;{{
                            nav.translatedTextAfterTrademark
                              ? nav.translatedTextAfterTrademark
                              : nav.fallbackTextAfterTrademark
                            }}</span
                          >
												</span>

                        <tooltip-badge
                          *ngIf='nav.pageNavTip && nav.pageNavTip.variants'
                          class='information-badge'
                          [tooltipTitle]='
														nav.pageNavTip.variants[cService.selectedLanguage.code]
															? nav.pageNavTip.variants[cService.selectedLanguage.code]
																	.subject
															: nav.pageNavTip.subject
													'
                          [tooltipMessage]='
														nav.pageNavTip.variants[cService.selectedLanguage.code]
															? nav.pageNavTip.variants[cService.selectedLanguage.code]
																	.message
															: nav.pageNavTip.message
													'
                        ></tooltip-badge>

                        <menu-notification-badge
                          *ngIf='nav.notificationsBadge?.display'
                          [id]='nav.id'
                          [tooltip]='nav.notificationsBadge.tooltip'
                          (click)='onlyBadge($event)'
                        ></menu-notification-badge>

                        <mat-icon
                          style='color: #ccc'
                          *ngIf='nav.isExternalUrl'
                          [matTooltip]="'MESSAGESANDWARNINGS.opensNewTab' | translate"
                        >
                          open_in_new
                        </mat-icon>
                      </h3>
                      <p matLine *ngIf='nav.details'>
                        <span class='direct-link-child-details'>{{ nav.details }}</span>
                      </p>
                    </a>
                  </mat-nav-list>
                </ng-template>

                <!-- Nav children -->
                <mat-nav-list>
                  <div
                    [id]='child.id'
                    *ngFor='let child of nav.children'
                    (click)='identifySelectedNav(child)'
                  >
                    <a
                      mat-list-item
                      [href]='child.url'
                      [class.selected-child-nav]='child.selected'
                      *ngIf='!child.hidden'
                      [target]="child.openInNewTab ? '_blank' : ''"
                    >
                      <mat-icon
                        style='color: #ccc'
                        *ngIf='child.isExternalUrl'
                        [matTooltip]="'MESSAGESANDWARNINGS.opensNewTab' | translate"
                      >
                        open_in_new
                      </mat-icon>
                      <h3 class='menu-title' matLine>
                        <span fxFlex>{{ child | getNavTitle }}</span>

                        <tooltip-badge
                          *ngIf='child.pageNavTip && child.pageNavTip.variants'
                          class='information-badge'
                          [tooltipTitle]='
														child.pageNavTip.variants[cService.selectedLanguage.code]
															? child.pageNavTip.variants[cService.selectedLanguage.code]
																	.subject
															: child.pageNavTip.subject
													'
                          [tooltipMessage]='
														child.pageNavTip.variants[cService.selectedLanguage.code]
															? child.pageNavTip.variants[cService.selectedLanguage.code]
																	.message
															: child.pageNavTip.message
													'
                        ></tooltip-badge>

                        <menu-notification-badge
                          *ngIf='child.notificationsBadge?.display'
                          [id]='child.id'
                          [tooltip]='child.notificationsBadge.tooltip'
                          (click)='onlyBadge($event)'
                        ></menu-notification-badge>
                      </h3>
                      <p matLine *ngIf='child.details'>
                        <span class='child-details'>{{ child.details }}</span>
                      </p>
                    </a>
                  </div>
                </mat-nav-list>
              </mat-expansion-panel>
            </ng-container>
          </mat-accordion>
        </div>
      </div>
    </mat-sidenav>

    <!-- Settings sidenav -->
    <mat-sidenav
      #settingsSidenav
      mode='over'
      position='end'
      *ngIf='authService.isAuthenticated() && cService.pageHeader.pageUiSettings?.hasMoreOptions'
      [opened]='
				cService?.userProfile?.distributorCompanies?.length > 0 &&
				cService?.userProfile?.distributorPermissions?.permMisDisplayDistributorPage != cService.permLevels.TRUE
			'
    >
      <mat-toolbar class='subtle-heading force'>
        <div>{{ 'OPTIONS.settings' | translate | uppercase }}</div>

        <span fxFlex></span>

        <div style='font-size: 10px; text-align: center'>
          <div style='height: 10px'>{{ 'GENERIC.version' | translate }}</div>
          <div>{{ cService.appVersion }}</div>
        </div>
      </mat-toolbar>

      <mat-accordion>
        <!-- Security -->
        <vrm-expansion-panel
          panelTitle="{{ 'SECURITY.accountAndSecurity' | translate }}"
          [subtleTitle]='true'
          [panelExpanded]='true'
        >
          <mat-nav-list class='nav-list-underlined'>
            <!-- Account Info -->
            <vrm-account-info [showSecurityPageButton]='false' [useMini]='true'></vrm-account-info>
            <mat-divider></mat-divider>

            <a
              mat-list-item
              [href]="'#/security'"
              (click)='toggleSettingsSidenav(0)'
              matTooltip="{{ 'GENERIC.goToPage' | translate }}"
            >
              {{ 'SECURITY.accountAndSecurity' | translate }}
            </a>

            <a
              mat-list-item
              [href]="'#/security'"
              *ngIf='!cService.userProfile?.isSso'
              (click)='toggleSettingsSidenav(1)'
            >
              {{ 'SECURITY.changePassword' | translate }}
            </a>
          </mat-nav-list>
        </vrm-expansion-panel>
      </mat-accordion>
    </mat-sidenav>

    <mat-sidenav-content>
      <router-outlet></router-outlet>
    </mat-sidenav-content>
  </mat-sidenav-container>

  <vrm-tooltip></vrm-tooltip>
</div>

<app-footer [internal]='true' *ngIf='authService.isAuthenticated()'></app-footer>
